import React, { useState, useEffect } from 'react';
import { Col, Row, Card, Form, Button, Spinner } from 'react-bootstrap';
import RenderizarProduto from '../components/Utils/RenderizarProduto';
import BotaoFlutuante from '../components/Button/BotaoFlutuante';
import SelecionarTipoCategoria from '../components/Utils/TipoCategoria';
import Swal from 'sweetalert2';
import { useProvider, Toast } from "../context/MenuProvider";
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom';

const CategoriaList = () => {
    const navigate = useNavigate();
    const [query, setQuery] = useState(''); // Termo de pesquisa
    const [categorias, setCategorias] = useState([]); // Categorias carregados
    const { tipo: t2 } = useParams();
    const [tipo, setTipo] = useState((t2??'').split(",")); // Categorias carregados
    const [nextUrl, setNextUrl] = useState(null); // URL da próxima página
    const { 
      setLinks, 
      setBtns,
      crud,
      hasPerms,
      setTitle,
    } = useProvider();
    
    
    const { get, loading } = crud || {};  // Obtendo os métodos do hook useCrud
    
    // Função para buscar categorias na API
    const buscarCategorias = async (novaBusca = false) => {
        const tipos = getTipo(tipo);
        if (!tipos) {
          setCategorias([]);
          return;
        }
        
        let url = `/gvendas/categorias/?ordering=categoria_pai__nome_da_categoria,nome_da_categoria&tipo__in=${tipos}&expand=categoria_pai&filtros=nome,descricao,empresa,id`;

        if (query) url += `&search=${query}`;
        
        
        if (novaBusca) {
            setCategorias([]); // Limpa os categorias anteriores
            setNextUrl(null); // Reseta o nextUrl
        } else if (nextUrl) {
            url = nextUrl; // Se não for nova busca, utiliza o nextUrl
        } else {
          url = null;
        }

        if (!url) return; // Evita chamada se já estiver loading ou sem URL válida
        try{
          const response = await get(url);
          if(response && response.length){
            const novosCategorias = response[0].results; // Corrigir para acessar o resultado correto
            setCategorias((categoriasAnteriores) => novaBusca ? novosCategorias : [...categoriasAnteriores, ...novosCategorias]);
            setNextUrl(response[0].next);
          }
          
        }catch(err){
          // Toast.fire({
          //     icon: "error",
          //     title: "Falha ao buscar categorias"
          // });
        }finally{
          
        }
    };

    // Carrega os categorias ao montar o componente ou aplicar um novo filtro
    useEffect(() => {
      setTitle("Categorias");
      buscarCategorias(true); // Sempre faz uma nova busca
    }, [query, tipo]);
    
    const getTipo = (tipo) => {
      const itens = tipo;// && tipo.length ? tipo : `rede,produtos,pessoais,negocio`;
    
      let lista = Array.isArray(itens)
        ? itens
        : itens.toString().split(',').map(i => i.trim());
    
      //alert(lista.join(',')); // <-- agora mostra sempre o valor final correto
    
      if (!hasPerms(["loja.view_produtos"])) {
        lista = lista.filter(item => item !== "produtos");
      }
      if (!hasPerms(["rede.view_apn"])) {
        lista = lista.filter(item => item !== "rede");
      }
      if (!hasPerms(["financas.view_financeiro"])) {
        lista = lista.filter(item => !["pessoais", "negocio"].includes(item));
      }
    
      return lista.join(',');
    };
    
    
    useEffect(() => {
      setLinks([
       // { name: 'Configurar estoque (Casal)', to: '/estoque/sincronizar' },
       // { name: 'Sincronizar categorias', to: '/estoque/sincronizar' },
      ]);
      setBtns([]);
      return () => {setLinks([]); setBtns([]);}
    }, [setLinks, setBtns]);
    
    
    
    // Detecta o fim da página para carregar mais categorias
    useEffect(() => {
        const handleScroll = () => {
            if (window.innerHeight + document.documentElement.scrollTop >= document.documentElement.offsetHeight - 100) {
                if (!loading) buscarCategorias();
            }
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, [loading, nextUrl]);
    
    
    return (
        <>
            <BotaoFlutuante to={`/categorias/novo${tipo?.length===1?`/${tipo}`:""}`} icon="bi-plus"></BotaoFlutuante>
            <div className="">
                <Form>
                      <Form.Group controlId="formCategoria" className="mb-3">
                        <div className="input-group">
                          <Form.Control 
                              type="text" 
                              placeholder="Pesquisa..." 
                              value={query} 
                              onChange={(e) => setQuery(e.target.value)} 
                          />
                          <Button variant="secondary" onClick={() => buscarCategorias(true)}>
                              <i className="bi bi-search"></i>
                          </Button>
                        </div>
                      </Form.Group>
                      {t2?.split(",").length !== 1 && (
                        <SelecionarTipoCategoria tipo={tipo} setTipo={setTipo} multiplos={true}/>
                      )}
                </Form>
                
                <div className="list-group mt-3">
                    {categorias.length > 0 ? (
                      categorias.map((x) => (
                        <RenderizarProduto
                          key={x.id}
                          lm="mb-1"
                          col="d-none"
                          bcolor={!x.empresa?`black`:`inherit`}
                          to={x.empresa?`/categorias/editar/${x.id}`:``}
                          text1={`${x.categoria_pai?.nome || ``}`}
                          titulo={`${x.nome}`}
                          text2={`${x.descricao}`}
                        />
                      ))
                    ) : (
                      !loading && <p className="text-center text-muted">Nenhuma categoria encontrada.</p>
                    )}
                    {loading && <p className="text-center"><Spinner animation="border" /></p>}
                    {nextUrl && !loading && (
                        <Button variant="secondary" onClick={() => buscarCategorias(false)} className="mt-2  text-center">
                            Buscar mais...
                        </Button>
                    )}
                </div>
            </div>
        </>
    );
};

export default CategoriaList;